import './polyfills';
import './index.scss';

import * as Sentry from '@sentry/react';
import { App } from 'app/App';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

import { performOneTimeSessionClear } from '@/app/lib/session-clear';

performOneTimeSessionClear();

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

if (window.location.host !== 'localhost:3001') {
  Sentry.init({
    dsn: 'https://e93cab77646c21c79d0fd4f7a207a1d7@o4506705898242048.ingest.us.sentry.io/4507208141701120',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        createRoutesFromChildren,
        matchRoutes,
        useLocation,
        useNavigationType,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const rootElement = document.getElementById('root')!;
ReactDOM.createRoot(rootElement).render(<App />);
// trigger build
